// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see OverdraftStatusEligibilityEvent
 */
export var OverdraftStatusEligibility = function (_a) {
    var isEligible = _a.isEligible;
    return ({
        name: "Overdraft Status Eligibility",
        parameters: {
            cdf_entity: "Overdraft",
            cdf_action: "Status",
            is_eligible: isEligible !== undefined && isEligible !== null ? isEligible.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see OverdraftStatusEnabledEvent
 */
export var OverdraftStatusEnabled = function (_a) {
    var isEnabled = _a.isEnabled, isPermanentlyDisabled = _a.isPermanentlyDisabled, reason = _a.reason;
    return ({
        name: "Overdraft Status Enabled",
        parameters: {
            cdf_entity: "Overdraft",
            cdf_action: "Status",
            is_enabled: isEnabled !== undefined && isEnabled !== null ? isEnabled.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_permanently_disabled: isPermanentlyDisabled !== undefined && isPermanentlyDisabled !== null ? isPermanentlyDisabled.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            reason: reason !== undefined && reason !== null ? reason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
